import {Component, Inject, Input, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {ProleisSuppliersState} from '../../../store/store.index';
import {APP_GUIDS, AppGuids} from '../../../../app.guids';
import {CreateDeliveryNoteComponent} from '../../overlays/create-delivery-note/create.delivery.note.component';
import {DeliveriesActions} from '../../../store/deliveries/deliveries.index';
import {ActivatedRoute} from '@angular/router';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {EditPlannedDeliveryComponent} from '../../overlays/edit-planned-delivery/edit.planned.delivery.component';
import {ProleisObject} from "@proleis/proleis-rest-client";

@Component({
  selector: 'ps-planned-delivery',
  templateUrl: 'planned.delivery.component.html',
  styleUrls: ['planned.delivery.component.scss']
})
export class PlannedDeliveryComponent implements OnInit {

  @Input()
  deliveries: ProleisObject[];
  @Input()
  isLoading: boolean;
  @Input()
  pos: ProleisObject;
  @Input()
  icons: Map<string, string>;
  @Input()
  incident: ProleisObject;

  constructor(private store: Store<ProleisSuppliersState>, @Inject(APP_GUIDS) private guids: AppGuids,
              private activatedRoute: ActivatedRoute, private bs: MatBottomSheet) {
  }


  ngOnInit() {

  }

  checkOpen(delivery: ProleisObject): boolean {
    return delivery.FREIGABE_GUID === this.guids.GUID_OPEN;
  }

  checkDelivered(delivery: ProleisObject): boolean {
    return delivery.FREIGABE_GUID === this.guids.GUID_DELIVERED;
  }

  checkCanceled(delivery: ProleisObject): boolean {
    return delivery.FREIGABE_GUID === this.guids.GUID_CANCELED;
  }

  hasIndexAi(): boolean {
    if (this.pos) {
      return !!this.pos.INDEX_AI;
    } else {
      return false;
    }
  }

  getBackground(delivery: ProleisObject): string {
    if (this.checkDelivered(delivery)) {
      return 'status-green';
    }
    if (this.checkCanceled(delivery)) {
      return 'status-red';
    }
    if (this.checkOpen(delivery)) {
      return 'status-blue';
    }
    if (!delivery.FREIGABE_GUID) {
      return 'status-grey';
    }
  }

  createDeliveryNote(delivery: ProleisObject) {
    this.bs.open(CreateDeliveryNoteComponent, {data: {delivery}})
      .afterDismissed().subscribe(bottomSheetData => {
      if (bottomSheetData) {
        this.store.dispatch(DeliveriesActions.CREATE_DELIVERYNOTE({
          orderId: this.activatedRoute.snapshot.params.id,
          posId: this.activatedRoute.snapshot.params.posId,
          deliveryNoteNumber: bottomSheetData.deliveryNr,
          deliveryComment: bottomSheetData.deliveryComment,
          deliveryCount: bottomSheetData.count,
          deliveryDate: bottomSheetData.date,
          deliveryId: delivery.PLANNED_DELIVERY_ID
        }));
      }
    });
  }

  openEditPlannedDeliveryBottomsheet(delivery: ProleisObject) {
    this.bs.open(EditPlannedDeliveryComponent, {
      data: {
        pboId: this.activatedRoute.snapshot.params.id,
        posId: this.activatedRoute.snapshot.params.posId,
        delivery,
        incident: this.incident
      }
    }).afterDismissed().subscribe(updatedDelivery => {
      console.log('update', updatedDelivery);
      this.store.dispatch(DeliveriesActions.UPDATE_PLANNED_DELIVERY({
        orderId: this.activatedRoute.snapshot.params.id,
        posId: this.activatedRoute.snapshot.params.posId,
        plannedDate: updatedDelivery.plannedDate,
        plannedCount: updatedDelivery.plannedCount,
        deliveryId: delivery.PLANNED_DELIVERY_ID,
        deliveryComment: updatedDelivery.deliveryComment,
        incidentId: updatedDelivery.incidentId
      }));
    });
  }

  cancelDelivery(noteId: string) {
    this.store.dispatch(DeliveriesActions.CANCEL_DELIVERY({
      deliveryNoteId: noteId,
      orderId: this.activatedRoute.snapshot.params.id,
      pseId: this.activatedRoute.snapshot.params.posId
    }));
  }

  deleteDelivery(delivery: ProleisObject) {
    this.store.dispatch(DeliveriesActions.DELETE_PLANNED_DELIVERY({
      orderId: this.activatedRoute.snapshot.params.id,
      posId: this.activatedRoute.snapshot.params.posId,
      deliveryId: delivery.PLANNED_DELIVERY_ID
    }));
  }

  downloadDeliveryNote(plannedDelivery: ProleisObject) {
    this.store.dispatch(DeliveriesActions.DOWNLOAD_DELIVERYNOTE({
      noteId: plannedDelivery.PBO_DELIVERY_ID
    }));
  }

}
